'use client';

import { ReactNode, useEffect } from 'react';

import { initDatadogLogs } from '@calm-web/logger';

import { useUser } from '@/hooks/store';
import { initAmplitude, setAmplitudeUserId } from '@/utils/analytics/amplitude';
import { initDatadogRum } from '@/utils/analytics/datadogRum';

export default function AnalyticsInitializer(): ReactNode {
	const { user } = useUser();

	// Initialize any analytics libraries
	useEffect(() => {
		if (typeof window !== 'undefined') {
			initAmplitude();
			initDatadogRum();
			initDatadogLogs({
				service: 'web-partner-portal',
				version: process.env.BUILD_ID,
				env: process.env.LOG_ENV ?? 'local',
			});
		}
	}, []);

	useEffect(() => {
		if (user?.email) {
			setAmplitudeUserId(user.email, user.accessPolicy?.allowed_user_role);
		} else {
			// Anonymize the current session
			setAmplitudeUserId(null, undefined);
		}
	}, [user]);

	return null;
}
